import { Button, Container } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';

import CustomBreadcrumbs from '@/commons/custom-breadcrumbs';
import { Iconic } from '@/commons/iconic';
import ListPage from '@/components/Table';
import { useCashRegisterContext } from '@/hooks/useCashRegisterContext';
import { PATH_DASHBOARD } from '@/routes/paths';
import { translates } from '@/utils/translate';
import { useOrdersContext } from '@/hooks/useOrderContext';
import { useOrder } from '@/hooks/useOrder';
import { useCompanyCategory } from '@/hooks/useCompanyCategory';
import { useEffect } from 'react';
import { Order } from '../types';
import { TABLE_HEAD_ORDERS } from '../utils/constants';

export default function OrderHistoryPage() {
  const { isFoodCompany } = useCompanyCategory();
  const navigate_orders: any = {
    view: PATH_DASHBOARD.orders.view,
    edit: PATH_DASHBOARD.orders.edit,
    openOrders: PATH_DASHBOARD.orders.open_orders
  };
  const title = 'Orders';
  const links = [
    { name: translates.dashboard, href: PATH_DASHBOARD.root },
    { name: translates.orders, href: PATH_DASHBOARD.orders.list },
    { name: translates.list },
  ];

  const { handleActualOrders } = useOrdersContext();
  const { data, isLoading, refetch, paginator, setPaginator } = useOrder({ filter: false });

  const { isOpen } = useCashRegisterContext();

  useEffect(() => {
    if (isOpen) {
      handleActualOrders();
      refetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Helmet>
        <title>
          {' '}
          {import.meta.env.VITE_TITLE_BUSINESS}: {title} List
        </title>
      </Helmet>

      <Container maxWidth={false}>
        <CustomBreadcrumbs
          heading={`${translates.list} ${title} `}
          links={links}
          action={[
            <Button
              component={RouterLink}
              to={PATH_DASHBOARD.orders.new}
              variant="contained"
              startIcon={<Iconic icon="eva:plus-fill" />}
            >
              {`${translates.new} ${translates.order} `}
            </Button>,
          ]}
        />

        <ListPage<Order, string>
          data={data?.data}
          navigateHandle={navigate_orders}
          isLoading={isLoading}
          dataStruct={TABLE_HEAD_ORDERS(isFoodCompany)}
          paginator={{ refresh: refetch, setPaginator, paginator }}
        />
      </Container>
    </>
  );
}
